(function ($) {
  $.fn.lmOnloadScroll = function(options) {
    // NOTE: Don't run logic below if nothing is in the dom
    if (!this.length) {
      return false;
    }

    // These are all the methods available for the plugin
    var methods = {};

    methods.scrollSchedule = function($context) {

        let _anchor  = location.hash.split('#').slice(1);
        let $anchor = $('[name="' + _anchor + '"]');

        if( $anchor.length > 0 ) {
          var _scrollOffset = $anchor.offset().top - ($('.header').height() - $('.series-menu:visible').height());

          $('html, body').stop().animate({'scrollTop': _scrollOffset}, 500);
          $anchor.trigger('click');
        }
    }

    // On load function
    methods.events = function($context) {
   $(document).ready(function(){

     let is_schedule =  $(document).find('body[class*="path-schedule"]').length;
     let _hash = location.hash;

     if ( 0 < is_schedule && _hash) {

       let anchorTimer = null;
       clearTimeout(anchorTimer);
       anchorTimer = setTimeout(
         methods.scrollSchedule($context)
       , 250);

     }

     let is_event =  $(document).find('body[class*="page-node-type-event"]').length;
     if (  0 < is_event ){

       let anchorTimer = null;
       clearTimeout(anchorTimer);
       anchorTimer = setTimeout(
           function() {

             let _factor = 1;
             let window_width = parseInt( $( window ).width());

             if( window_width > 970 && window_width < 997){
               _factor = 3.8;
             } else if (window_width > 998){
               _factor = 1.5;
             }

             let $anchor = $('#topOfInfo');
             let _height_1 = $('.header').height();
             let _height_2 = $('.title-bar__title').height();
             let  _scrollOffset = $anchor.offset().top - (_height_1 - ( _factor * _height_2));
             $('html, body').stop().animate({'scrollTop': _scrollOffset}, 800);

//             console.log('window_width :' +  window_width);
//             console.log('$anchor.offset().top :' +  $anchor.offset().top);
//             console.log('_height_1 :' +  _height_1);
//             console.log('_height_2 :' +  _height_2);
//             console.log('_factor :' +  _factor);
//             console.log('scrollTop :' +  _scrollOffset);
           }
       , 300);
     }

      });
    }

    // Run once methods when jquery plugin is called
    methods.events(this);
};

}(jQuery));
